export default "__VITE_ASSET__DSDSSqS6__"